import {
  ITextInputFieldConfigurationClient,
  ITextInputFieldConfigurationServer,
} from "./interface";

export const transformTextInputFieldConfigClientToServer = (
  fieldConfigClient: ITextInputFieldConfigurationClient
): ITextInputFieldConfigurationServer => {
  const {
    placeholder,
    initialValue,
    writeJavascript,
    initialValueWithAccessKey,
    maskedField,
    showVirtualKeyboard,
  } = fieldConfigClient;
  const fieldConfigServer = {
    placeHolder: placeholder,
    initialValue: initialValue,
    writeJavascript: writeJavascript,
    showVirtualKeyboard: showVirtualKeyboard,
    maskedField: {
      isMaskingEnabled: maskedField?.isMaskingEnabled,
      maskChar: maskedField?.maskChar,
      maxCharacter: maskedField?.maxCharacter,
      maskedIndexes: maskedField?.maskedIndexes,
    },
    initialValueWithAccessKey: initialValueWithAccessKey,
  };
  return fieldConfigServer;
};

export const transformTextInputConfigServerToClient = (
  fieldConfigServer: ITextInputFieldConfigurationServer
): ITextInputFieldConfigurationClient => {
  const {
    placeHolder,
    initialValue,
    writeJavascript,
    maskedField,
    initialValueWithAccessKey,
    showVirtualKeyboard,
  } = fieldConfigServer;
  const fieldConfigClient = {
    placeholder: placeHolder,
    initialValue: initialValue,
    writeJavascript: writeJavascript,
    showVirtualKeyboard: showVirtualKeyboard,
    maskedField: {
      isMaskingEnabled: maskedField?.isMaskingEnabled,
      maskChar: maskedField?.maskChar,
      maxCharacter: maskedField?.maxCharacter,
      maskedIndexes: maskedField?.maskedIndexes,
    },
    initialValueWithAccessKey: initialValueWithAccessKey,
  };
  return fieldConfigClient;
};
